/**
 * Backend API origin for Admin. CRA inlines env at build time; this corrects
 * stale production builds that still point at legacy hosts.
 *
 * **Local dev (`npm start` on localhost) + hosted API (`https://api.beentara.com`):**
 * defaults to same-origin URLs (`""`) so `src/setupProxy.js` forwards `/login`, etc. to
 * the API. That avoids browser CORS failures (e.g. POST login showing "Provisional headers").
 *
 * To call the API directly from the browser instead, set:
 * `REACT_APP_USE_DIRECT_API=1` (requires CORS on the server for http://localhost:3000).
 *
 * Local Node API: set `REACT_APP_LINK=http://localhost:PORT` — always uses that full URL
 * (no proxy). Optional: `REACT_APP_PROXY_TARGET` overrides the proxy upstream when using
 * the default empty base (defaults to https://api.beentara.com).
 */
const DEFAULT = "https://api.beentara.com";

function normalize(u) {
  return String(u || "")
    .trim()
    .replace(/\/+$/, "");
}

const raw = normalize(process.env.REACT_APP_LINK);

function resolvedBase() {
  const base = !raw || raw.includes("100billionfinance.in") ? DEFAULT : raw;

  if (process.env.NODE_ENV !== "development") {
    return base;
  }
  if (typeof window === "undefined") {
    return base;
  }

  const host = window.location.hostname || "";
  const onLoopback = host === "localhost" || host === "127.0.0.1";
  if (!onLoopback) {
    return base;
  }

  const targetsLocalBackend = /localhost|127\.0\.0\.1/i.test(base);
  if (targetsLocalBackend) {
    return base;
  }

  const useDirectApi =
    process.env.REACT_APP_USE_DIRECT_API === "1" ||
    process.env.REACT_APP_USE_DIRECT_API === "true";

  if (
    !useDirectApi &&
    /^https?:\/\//i.test(base) &&
    !/localhost|127\.0\.0\.1/i.test(base)
  ) {
    return "";
  }

  return base;
}

export const API_BASE_URL = resolvedBase();
